import '../scss/modal.scss';
import { Modal } from 'antd';

import hero from '../assets/dtp/dtp-hero.png';
import results from '../assets/dtp/dtp-results.png';
import solutions1 from '../assets/dtp/dtp-solutions-1.png';
import solutions2 from '../assets/dtp/dtp-solutions-2.png';
import solutions3 from '../assets/dtp/dtp-solutions-3.png';

export const DTPModal = ({open, onCancel}) =>{
    return(
        <Modal
        title="" 
        open={open} 
        onCancel={onCancel}
        footer={false}
        width={824}
        >
            <div className='modal'>
                <h1>Digital Transformation Projects</h1>
                <img src={hero} width={'100%'} alt='Digital Transformation Projects'/>
                <div className='section'>
                    <h2>The Customer</h2>
                    <p>The company is a global entity operating in the storage terminal industry that specializes in the storage and distribution of chemicals and petroleum products. It possesses extensive infrastructure including deep-water berths, rail access, and numerous storage tanks, ensuring efficient and safe handling of diverse products.</p>
                </div>
                <div className='section'>
                    <h2>The Challenge</h2>
                    <p>
                        Time-consuming processes involving massive paperwork across Marine, Truck, and Rail operations, due to manual processes.
                        <br/><br/>
                        Planning and scheduling processes involve manual inputs across multiple tools that is prone to human error resulting in delays.
                    </p>
                </div>
                <div className='section'>
                    <h2>The Solution</h2>
                    <p>
                        Developed an application to digitize the operations across Marine, Truck, and Rail activities, capture time stamps, and facilitate real time transfer of documents for faster communication.
                        <br/>
                        <br/>
                        Designed and deployed the Systems Integrations between a 3rd party provider of planning and scheduling tool with the existing ERP system of the client to eliminate manual planning and automate the posting of the schedule into the ERP.
                    </p>
                </div>
                <div className='group-img'>
                    <img src={solutions1} alt='Digital Transformation Solutions'/>
                    <img src={solutions2} alt='Digital Transformation Solutions'/>
                </div>
                <img src={solutions3} width={'100%'} alt='Digital Transformation Solutions'/>
                <div className='section'>
                    <h2>The Results</h2>
                    <p>
                        Digitization of Marine, Truck, and Rail operations, with digital capture of other services, time stamps, and data sharing of real-time operational updates across all modalities.
                        <br/>
                        <br/>
                        Digitization of planning and scheduling tools, which streamline workflow processes bringing seamless integration, eliminating errors, saving time, and overall increasing efficiency in this work process.
                        <br/>
                        <br/>
                        Likewise, the digitization effort led to producing reliable integration within the company, making data-based decisions that are significant in addressing critical paths and everyday operations. 
                    </p>
                </div>
                <img src={results} width={'100%'} alt='Digital Transformation Results'/>
            </div>
        </Modal>
    )
}